const React = require('react');
const changeProviderProvider = require('mn-utils/changeProviderProvider');
const onEnterProvider = require('mn-utils/onEnterProvider');
const {
  LINK_RESET_SECURITY_VERIFICATION,
  LINK_BLOCKED,
  LINK_DASHBOARD,
  LINK_SIGN_IN,
} = require('../../../../constants/links');
const withState = require('../../../../utils/withState');
const {
  apiAuthTfaVerify,
} = require('../../../../api/_auth');
const {
  Link,
  replaceLocation,
} = require('../../../../router');
const {
  account$,
  cachedAccount$,
  login$,
} = require('../../../../emitters/account');
const ButtonAccept = require('../../../dumb/Button/Accept');
const TextFieldI = require('../../../dumb/TextField/I');
const Base = require('./components/Base');


module.exports = withState((setState, self, onMount) => {
  let _codeNode;
  const changeProvider = changeProviderProvider(setState);
  const handleChangeCode = changeProvider('code');

  function handleCodeRef(node) {
    node && (_codeNode = node);
  }


  return (state) => {
    const {
      clicked,
      cachedAccount,
    } = state;

    if (!cachedAccount) {
      replaceLocation({
        path: LINK_SIGN_IN,
      });
      return null;
    }
    if (!cachedAccount.need_tfa) {
      replaceLocation({
        path: LINK_DASHBOARD,
      });
      return null;
    }

    const oneTimePassword = state.code || '';
    const disabled = oneTimePassword.length !== 6;

    function handleSubmit() {
      _codeNode && _codeNode.blur();
      if (state.error) return;
      if (disabled) {
        setState({
          clicked: true,
        });
        return;
      }

      setState({
        loading: true,
      });
      apiAuthTfaVerify({
        code: oneTimePassword,
      }).finally((error, response) => {
        setState({
          loading: false,
        });

        if (error) {
          return;
        }

        if (response && response.blocked) {
          replaceLocation({
            path: LINK_BLOCKED + state.email + '/',
          });
          return;
        }
        account$.emit(cachedAccount),
        replaceLocation({
          path: LINK_DASHBOARD,
        });
      });
    }


    return (
      <Base
        cachedAccount={cachedAccount}
        loading={state.loading}
        title="Security verification"
        content={(<div>
          <TextFieldI
            inputRef={handleCodeRef}
            error={clicked && disabled}
            value={oneTimePassword}
            onChange={handleChangeCode}
            onKeyPress={onEnterProvider(handleSubmit)}
          />
          <div className="hmin48 ph25 pv15 f12 fw3 lh18 lts0em tl c717275">
            Please enter the authentication code
          </div>
        </div>)}
        control={(
          <ButtonAccept
            disabled={clicked && disabled}
            onClick={handleSubmit}
          >Submit</ButtonAccept>
        )}
        additional={(
          <div className="f12 fw3 lh lts0em">
            <Link
              href={LINK_RESET_SECURITY_VERIFICATION}
              className="c5B47FF olN tdU dn f12 fw3 o70:h"
            >Lost access to verification?</Link>
          </div>
        )}
      />
    );
  };
}, {
  email: login$,
  cachedAccount: cachedAccount$,
});
